import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BiPermissionService, WorkspaceDomainService, WorkspaceListItem } from '@selfai-platform/bi-domain';
import { BiPermission, KdConfigService } from '@selfai-platform/shared';
import { ActionsForItemService, DataListItemAction, KNOWLEDGE_DESIGNER_ROOT_ROUTE } from '@selfai-platform/shell';
import { Observable, of, take } from 'rxjs';
import { WorkspaceDataListViewService } from './workspace-data-list-view.service';

@Injectable()
export class WorkspaceActionsForItemService extends ActionsForItemService<WorkspaceListItem> {
  constructor(
    private readonly workspaceDataListViewService: WorkspaceDataListViewService,
    private readonly permissionService: BiPermissionService,
    private readonly router: Router,
    private readonly configService: KdConfigService,
    private readonly workspaceDomainService: WorkspaceDomainService,
  ) {
    super();
  }

  override getActionsForItem(workspace: WorkspaceListItem): Observable<DataListItemAction[]> {
    const menuItems: DataListItemAction[] = [];
    // TODO: add actions for workspace list
    if (this.hasPermission(BiPermission.KD_WORKSPACE_EDIT_ALL)) {
      menuItems.push({
        labelTranslate: 'msg.workspace-list.table-actions.permissions',
        icon: 'pi pi-user-edit',
        action: () =>
          this.router.navigate(['/', KNOWLEDGE_DESIGNER_ROOT_ROUTE, 'workspace', workspace.id, 'manage-roles']),
      });
    }

    if (this.hasPermission(BiPermission.KD_WORKSPACE_DELETE_ALL)) {
      menuItems.push({
        labelTranslate: 'msg.workspace-list.table-actions.remove',
        icon: 'pi pi-trash',
        action: (eventTarget) => this.workspaceDataListViewService.remove(workspace, eventTarget),
      });
    }

    if (this.configService.getConfig().features.datasourceExportImport) {
      menuItems.push({
        icon: 'pi pi-download',
        labelTranslate: 'msg.workbook-toolbar.menu.download-migration-artifact',
        action: () => this.downloadMigrationArtifact(workspace.id, workspace.name),
      });
    }

    return of(menuItems);
  }

  hasPermission(permission: BiPermission): boolean {
    return this.permissionService.hasPermission(permission);
  }

  private downloadMigrationArtifact(workspaceId: string, workspaceName?: string): void {
    const safeName = (workspaceName || 'workspace').replace(/[^a-zA-Z0-9_-]+/g, '');
    const fileName = `migration-${safeName}.zip`;

    this.workspaceDomainService.downloadMigrationArtifact(workspaceId, fileName).pipe(take(1)).subscribe();
  }
}
